webpackJsonp([0],Array(59).concat([
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(235)
}
var Component = __webpack_require__(75)(
  /* script */
  __webpack_require__(137),
  /* template */
  __webpack_require__(214),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-57724486",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(230)
}
var Component = __webpack_require__(75)(
  /* script */
  __webpack_require__(138),
  /* template */
  __webpack_require__(209),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3b96ae2b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(224)
  __webpack_require__(225)
  __webpack_require__(226)
}
var Component = __webpack_require__(75)(
  /* script */
  __webpack_require__(139),
  /* template */
  __webpack_require__(206),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1023aae3",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(231)
}
var Component = __webpack_require__(75)(
  /* script */
  __webpack_require__(140),
  /* template */
  __webpack_require__(210),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3cdc4f8f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(232)
}
var Component = __webpack_require__(75)(
  /* script */
  __webpack_require__(141),
  /* template */
  __webpack_require__(211),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-424e5632",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(234)
}
var Component = __webpack_require__(75)(
  /* script */
  __webpack_require__(142),
  /* template */
  __webpack_require__(213),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-57630ea3",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(220)
}
var Component = __webpack_require__(75)(
  /* script */
  __webpack_require__(143),
  /* template */
  __webpack_require__(202),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-00252dc8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(35)('wks');
var uid = __webpack_require__(33);
var Symbol = __webpack_require__(0).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 72 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(118)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction) {
  isProduction = _isProduction

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[data-vue-ssr-id~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),
/* 74 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 75 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(25).f;
var has = __webpack_require__(24);
var TAG = __webpack_require__(71)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(27);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 78 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(94), __esModule: true };

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(26);
var TAG = __webpack_require__(71)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(0).document;
module.exports = document && document.documentElement;


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(78);
var $export = __webpack_require__(23);
var redefine = __webpack_require__(91);
var hide = __webpack_require__(22);
var has = __webpack_require__(24);
var Iterators = __webpack_require__(74);
var $iterCreate = __webpack_require__(101);
var setToStringTag = __webpack_require__(76);
var getPrototypeOf = __webpack_require__(106);
var ITERATOR = __webpack_require__(71)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 83 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(21);
var isObject = __webpack_require__(2);
var newPromiseCapability = __webpack_require__(77);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(21);
var aFunction = __webpack_require__(27);
var SPECIES = __webpack_require__(71)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(28);
var invoke = __webpack_require__(98);
var html = __webpack_require__(81);
var cel = __webpack_require__(29);
var global = __webpack_require__(0);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(26)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(109)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(82)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(110);
var global = __webpack_require__(0);
var hide = __webpack_require__(22);
var Iterators = __webpack_require__(74);
var TO_STRING_TAG = __webpack_require__(71)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(80);
var ITERATOR = __webpack_require__(71)('iterator');
var Iterators = __webpack_require__(74);
module.exports = __webpack_require__(5).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(21);
var dPs = __webpack_require__(105);
var enumBugKeys = __webpack_require__(34);
var IE_PROTO = __webpack_require__(30)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(29)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(81).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(22);


/***/ }),
/* 92 */
/***/ (function(module, exports) {



/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export pt_br */
/* unused harmony export en */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return i18n; });
var pt_br = {
  autor: 'autor | autores',
  baixar_trabalho: 'Baixar o @:trabalho_alt.s',
  corpo_editorial: 'Corpo Editorial',
  eixo: 'eixo | eixos',
  eixo_alt: {
    s: 'eixo',
    p: 'eixos'
  },
  eixo_tematico: '@:eixo_alt.s Temático | @:eixo_alt.p Temáticos',
  eixos_publicados: '@:eixo_alt.p Publicados',
  inicio: 'início',
  instituicao: 'instituição | instituições',
  nao_ha_trabalhos_pesquisa: 'Não há @:trabalho_alt.p que correspondem à sua pesquisa',
  nenhuma_pessoa_encontrada: 'Nenhuma pessoa encontrada',
  nenhuma_pessoa_encontrada_com_letra: '@:nenhuma_pessoa_encontrada com a letra \"{letra}\"',
  palavra_chave: 'palavra-chave | palavras-chave',
  pesquisa: 'pesquisa',
  placeholder_pesquise_por_nome: 'Pesquise por nome, filiação, ...',
  placeholder_pesquise_por_titulo: 'Pesquise por título, autor, ...',
  publicacao: 'publicação | publicações',
  resumo: 'resumo | resumos',
  trabalho: 'trabalho | trabalhos',
  trabalho_alt: {
    s: 'trabalho',
    p: 'trabalhos'
  },
  trabalho_publicado: '@:trabalho_alt.s publicado | @:trabalho_alt.p publicados'
};

var en = {
  autor: 'author | authors',
  baixar_trabalho: 'Download @:trabalho_alt.s',
  corpo_editorial: 'Organizing Committee',
  eixo: 'theme | themes',
  eixo_alt: {
    s: 'theme',
    p: 'themes'
  },
  eixo_tematico: 'thematic area | thematic areas',
  eixos_publicados: 'published @:eixo_alt.p',
  inicio: 'home',
  instituicao: 'institution | institutions',
  nao_ha_trabalhos_pesquisa: 'There is no @:trabalho_alt.p matched your search',
  nenhuma_pessoa_encontrada: 'No people found',
  nenhuma_pessoa_encontrada_com_letra: '@:nenhuma_pessoa_encontrada with the letter \"{letra}\"',
  palavra_chave: 'keyword | keywords',
  pesquisa: 'search',
  placeholder_pesquise_por_nome: 'Search for name, membership, ...',
  placeholder_pesquise_por_titulo: 'Search for title, author, ...',
  publicacao: 'paper | papers',
  resumo: 'abstract | abstracts',
  trabalho: 'work | works',
  trabalho_alt: {
    s: 'work',
    p: 'works'
  },
  trabalho_publicado: 'published @:trabalho_alt.s | published @:trabalho_alt.p'
};

var i18n = {
  messages: {
    pt_br: pt_br,
    en: en
  }
};



/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(92);
__webpack_require__(87);
__webpack_require__(88);
__webpack_require__(111);
__webpack_require__(112);
__webpack_require__(113);
module.exports = __webpack_require__(5).Promise;


/***/ }),
/* 95 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 96 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(28);
var call = __webpack_require__(100);
var isArrayIter = __webpack_require__(99);
var anObject = __webpack_require__(21);
var toLength = __webpack_require__(37);
var getIterFn = __webpack_require__(89);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 98 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(74);
var ITERATOR = __webpack_require__(71)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(21);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(90);
var descriptor = __webpack_require__(32);
var setToStringTag = __webpack_require__(76);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(22)(IteratorPrototype, __webpack_require__(71)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(71)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 103 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var macrotask = __webpack_require__(86).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(26)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver
  } else if (Observer) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    var promise = Promise.resolve();
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(25);
var anObject = __webpack_require__(21);
var getKeys = __webpack_require__(31);

module.exports = __webpack_require__(1) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(24);
var toObject = __webpack_require__(36);
var IE_PROTO = __webpack_require__(30)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__(22);
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(0);
var core = __webpack_require__(5);
var dP = __webpack_require__(25);
var DESCRIPTORS = __webpack_require__(1);
var SPECIES = __webpack_require__(71)('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(9);
var defined = __webpack_require__(8);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(95);
var step = __webpack_require__(103);
var Iterators = __webpack_require__(74);
var toIObject = __webpack_require__(7);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(82)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(78);
var global = __webpack_require__(0);
var ctx = __webpack_require__(28);
var classof = __webpack_require__(80);
var $export = __webpack_require__(23);
var isObject = __webpack_require__(2);
var aFunction = __webpack_require__(27);
var anInstance = __webpack_require__(96);
var forOf = __webpack_require__(97);
var speciesConstructor = __webpack_require__(85);
var task = __webpack_require__(86).set;
var microtask = __webpack_require__(104)();
var newPromiseCapabilityModule = __webpack_require__(77);
var perform = __webpack_require__(83);
var promiseResolve = __webpack_require__(84);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(71)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value);
            if (domain) domain.exit();
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  if (promise._h == 1) return false;
  var chain = promise._a || promise._c;
  var i = 0;
  var reaction;
  while (chain.length > i) {
    reaction = chain[i++];
    if (reaction.fail || !isUnhandled(reaction.promise)) return false;
  } return true;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(107)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(76)($Promise, PROMISE);
__webpack_require__(108)(PROMISE);
Wrapper = __webpack_require__(5)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(102)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(23);
var core = __webpack_require__(5);
var global = __webpack_require__(0);
var speciesConstructor = __webpack_require__(85);
var promiseResolve = __webpack_require__(84);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(23);
var newPromiseCapability = __webpack_require__(77);
var perform = __webpack_require__(83);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ }),
/* 119 */
/***/ (function(module, exports) {

var characterMap = {
	"À": "A",
	"Á": "A",
	"Â": "A",
	"Ã": "A",
	"Ä": "A",
	"Å": "A",
	"Ấ": "A",
	"Ắ": "A",
	"Ẳ": "A",
	"Ẵ": "A",
	"Ặ": "A",
	"Æ": "AE",
	"Ầ": "A",
	"Ằ": "A",
	"Ȃ": "A",
	"Ç": "C",
	"Ḉ": "C",
	"È": "E",
	"É": "E",
	"Ê": "E",
	"Ë": "E",
	"Ế": "E",
	"Ḗ": "E",
	"Ề": "E",
	"Ḕ": "E",
	"Ḝ": "E",
	"Ȇ": "E",
	"Ì": "I",
	"Í": "I",
	"Î": "I",
	"Ï": "I",
	"Ḯ": "I",
	"Ȋ": "I",
	"Ð": "D",
	"Ñ": "N",
	"Ò": "O",
	"Ó": "O",
	"Ô": "O",
	"Õ": "O",
	"Ö": "O",
	"Ø": "O",
	"Ố": "O",
	"Ṍ": "O",
	"Ṓ": "O",
	"Ȏ": "O",
	"Ù": "U",
	"Ú": "U",
	"Û": "U",
	"Ü": "U",
	"Ý": "Y",
	"à": "a",
	"á": "a",
	"â": "a",
	"ã": "a",
	"ä": "a",
	"å": "a",
	"ấ": "a",
	"ắ": "a",
	"ẳ": "a",
	"ẵ": "a",
	"ặ": "a",
	"æ": "ae",
	"ầ": "a",
	"ằ": "a",
	"ȃ": "a",
	"ç": "c",
	"ḉ": "c",
	"è": "e",
	"é": "e",
	"ê": "e",
	"ë": "e",
	"ế": "e",
	"ḗ": "e",
	"ề": "e",
	"ḕ": "e",
	"ḝ": "e",
	"ȇ": "e",
	"ì": "i",
	"í": "i",
	"î": "i",
	"ï": "i",
	"ḯ": "i",
	"ȋ": "i",
	"ð": "d",
	"ñ": "n",
	"ò": "o",
	"ó": "o",
	"ô": "o",
	"õ": "o",
	"ö": "o",
	"ø": "o",
	"ố": "o",
	"ṍ": "o",
	"ṓ": "o",
	"ȏ": "o",
	"ù": "u",
	"ú": "u",
	"û": "u",
	"ü": "u",
	"ý": "y",
	"ÿ": "y",
	"Ā": "A",
	"ā": "a",
	"Ă": "A",
	"ă": "a",
	"Ą": "A",
	"ą": "a",
	"Ć": "C",
	"ć": "c",
	"Ĉ": "C",
	"ĉ": "c",
	"Ċ": "C",
	"ċ": "c",
	"Č": "C",
	"č": "c",
	"C̆": "C",
	"c̆": "c",
	"Ď": "D",
	"ď": "d",
	"Đ": "D",
	"đ": "d",
	"Ē": "E",
	"ē": "e",
	"Ĕ": "E",
	"ĕ": "e",
	"Ė": "E",
	"ė": "e",
	"Ę": "E",
	"ę": "e",
	"Ě": "E",
	"ě": "e",
	"Ĝ": "G",
	"Ǵ": "G",
	"ĝ": "g",
	"ǵ": "g",
	"Ğ": "G",
	"ğ": "g",
	"Ġ": "G",
	"ġ": "g",
	"Ģ": "G",
	"ģ": "g",
	"Ĥ": "H",
	"ĥ": "h",
	"Ħ": "H",
	"ħ": "h",
	"Ḫ": "H",
	"ḫ": "h",
	"Ĩ": "I",
	"ĩ": "i",
	"Ī": "I",
	"ī": "i",
	"Ĭ": "I",
	"ĭ": "i",
	"Į": "I",
	"į": "i",
	"İ": "I",
	"ı": "i",
	"Ĳ": "IJ",
	"ĳ": "ij",
	"Ĵ": "J",
	"ĵ": "j",
	"Ķ": "K",
	"ķ": "k",
	"Ḱ": "K",
	"ḱ": "k",
	"K̆": "K",
	"k̆": "k",
	"Ĺ": "L",
	"ĺ": "l",
	"Ļ": "L",
	"ļ": "l",
	"Ľ": "L",
	"ľ": "l",
	"Ŀ": "L",
	"ŀ": "l",
	"Ł": "l",
	"ł": "l",
	"Ḿ": "M",
	"ḿ": "m",
	"M̆": "M",
	"m̆": "m",
	"Ń": "N",
	"ń": "n",
	"Ņ": "N",
	"ņ": "n",
	"Ň": "N",
	"ň": "n",
	"ŉ": "n",
	"N̆": "N",
	"n̆": "n",
	"Ō": "O",
	"ō": "o",
	"Ŏ": "O",
	"ŏ": "o",
	"Ő": "O",
	"ő": "o",
	"Œ": "OE",
	"œ": "oe",
	"P̆": "P",
	"p̆": "p",
	"Ŕ": "R",
	"ŕ": "r",
	"Ŗ": "R",
	"ŗ": "r",
	"Ř": "R",
	"ř": "r",
	"R̆": "R",
	"r̆": "r",
	"Ȓ": "R",
	"ȓ": "r",
	"Ś": "S",
	"ś": "s",
	"Ŝ": "S",
	"ŝ": "s",
	"Ş": "S",
	"Ș": "S",
	"ș": "s",
	"ş": "s",
	"Š": "S",
	"š": "s",
	"Ţ": "T",
	"ţ": "t",
	"ț": "t",
	"Ț": "T",
	"Ť": "T",
	"ť": "t",
	"Ŧ": "T",
	"ŧ": "t",
	"T̆": "T",
	"t̆": "t",
	"Ũ": "U",
	"ũ": "u",
	"Ū": "U",
	"ū": "u",
	"Ŭ": "U",
	"ŭ": "u",
	"Ů": "U",
	"ů": "u",
	"Ű": "U",
	"ű": "u",
	"Ų": "U",
	"ų": "u",
	"Ȗ": "U",
	"ȗ": "u",
	"V̆": "V",
	"v̆": "v",
	"Ŵ": "W",
	"ŵ": "w",
	"Ẃ": "W",
	"ẃ": "w",
	"X̆": "X",
	"x̆": "x",
	"Ŷ": "Y",
	"ŷ": "y",
	"Ÿ": "Y",
	"Y̆": "Y",
	"y̆": "y",
	"Ź": "Z",
	"ź": "z",
	"Ż": "Z",
	"ż": "z",
	"Ž": "Z",
	"ž": "z",
	"ſ": "s",
	"ƒ": "f",
	"Ơ": "O",
	"ơ": "o",
	"Ư": "U",
	"ư": "u",
	"Ǎ": "A",
	"ǎ": "a",
	"Ǐ": "I",
	"ǐ": "i",
	"Ǒ": "O",
	"ǒ": "o",
	"Ǔ": "U",
	"ǔ": "u",
	"Ǖ": "U",
	"ǖ": "u",
	"Ǘ": "U",
	"ǘ": "u",
	"Ǚ": "U",
	"ǚ": "u",
	"Ǜ": "U",
	"ǜ": "u",
	"Ứ": "U",
	"ứ": "u",
	"Ṹ": "U",
	"ṹ": "u",
	"Ǻ": "A",
	"ǻ": "a",
	"Ǽ": "AE",
	"ǽ": "ae",
	"Ǿ": "O",
	"ǿ": "o",
	"Þ": "TH",
	"þ": "th",
	"Ṕ": "P",
	"ṕ": "p",
	"Ṥ": "S",
	"ṥ": "s",
	"X́": "X",
	"x́": "x",
	"Ѓ": "Г",
	"ѓ": "г",
	"Ќ": "К",
	"ќ": "к",
	"A̋": "A",
	"a̋": "a",
	"E̋": "E",
	"e̋": "e",
	"I̋": "I",
	"i̋": "i",
	"Ǹ": "N",
	"ǹ": "n",
	"Ồ": "O",
	"ồ": "o",
	"Ṑ": "O",
	"ṑ": "o",
	"Ừ": "U",
	"ừ": "u",
	"Ẁ": "W",
	"ẁ": "w",
	"Ỳ": "Y",
	"ỳ": "y",
	"Ȁ": "A",
	"ȁ": "a",
	"Ȅ": "E",
	"ȅ": "e",
	"Ȉ": "I",
	"ȉ": "i",
	"Ȍ": "O",
	"ȍ": "o",
	"Ȑ": "R",
	"ȑ": "r",
	"Ȕ": "U",
	"ȕ": "u",
	"B̌": "B",
	"b̌": "b",
	"Č̣": "C",
	"č̣": "c",
	"Ê̌": "E",
	"ê̌": "e",
	"F̌": "F",
	"f̌": "f",
	"Ǧ": "G",
	"ǧ": "g",
	"Ȟ": "H",
	"ȟ": "h",
	"J̌": "J",
	"ǰ": "j",
	"Ǩ": "K",
	"ǩ": "k",
	"M̌": "M",
	"m̌": "m",
	"P̌": "P",
	"p̌": "p",
	"Q̌": "Q",
	"q̌": "q",
	"Ř̩": "R",
	"ř̩": "r",
	"Ṧ": "S",
	"ṧ": "s",
	"V̌": "V",
	"v̌": "v",
	"W̌": "W",
	"w̌": "w",
	"X̌": "X",
	"x̌": "x",
	"Y̌": "Y",
	"y̌": "y",
	"A̧": "A",
	"a̧": "a",
	"B̧": "B",
	"b̧": "b",
	"Ḑ": "D",
	"ḑ": "d",
	"Ȩ": "E",
	"ȩ": "e",
	"Ɛ̧": "E",
	"ɛ̧": "e",
	"Ḩ": "H",
	"ḩ": "h",
	"I̧": "I",
	"i̧": "i",
	"Ɨ̧": "I",
	"ɨ̧": "i",
	"M̧": "M",
	"m̧": "m",
	"O̧": "O",
	"o̧": "o",
	"Q̧": "Q",
	"q̧": "q",
	"U̧": "U",
	"u̧": "u",
	"X̧": "X",
	"x̧": "x",
	"Z̧": "Z",
	"z̧": "z",
};

var chars = Object.keys(characterMap).join('|');
var allAccents = new RegExp(chars, 'g');
var firstAccent = new RegExp(chars, '');

var removeAccents = function(string) {	
	return string.replace(allAccents, function(match) {
		return characterMap[match];
	});
};

var hasAccents = function(string) {
	return !!string.match(firstAccent);
};

module.exports = removeAccents;
module.exports.has = hasAccents;
module.exports.remove = removeAccents;


/***/ }),
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(127), __esModule: true };

/***/ }),
/* 126 */,
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(88);
__webpack_require__(87);
module.exports = __webpack_require__(130);


/***/ }),
/* 128 */,
/* 129 */,
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(21);
var get = __webpack_require__(89);
module.exports = __webpack_require__(5).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_remove_accents__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_remove_accents___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_remove_accents__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__langs_anais__ = __webpack_require__(93);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'anaisAutor',
  props: {},
  components: {},
  filters: {},
  watch: {},
  computed: {
    autor: function autor() {
      if (this.$route.params.autor_id) {
        var autor_id = this.$route.params.autor_id;
        var ret = this.autores.find(function (a) {
          return a.id == autor_id;
        });
        if (!ret) {
          // não encontrei o autor
          // volto para autores
          this.$router.replace('/autores');
          return this.autores[0];
        }
        return ret;
      }
      return this.autores[0];
    },


    // eu preciso fazer um computed
    // pq eu qro acessar essas variáveis diretamente do <template>
    eixos: function (_eixos) {
      function eixos() {
        return _eixos.apply(this, arguments);
      }

      eixos.toString = function () {
        return _eixos.toString();
      };

      return eixos;
    }(function () {
      return eixos;
    }),
    autores: function (_autores) {
      function autores() {
        return _autores.apply(this, arguments);
      }

      autores.toString = function () {
        return _autores.toString();
      };

      return autores;
    }(function () {
      return autores;
    }),
    palavras_chaves: function (_palavras_chaves) {
      function palavras_chaves() {
        return _palavras_chaves.apply(this, arguments);
      }

      palavras_chaves.toString = function () {
        return _palavras_chaves.toString();
      };

      return palavras_chaves;
    }(function () {
      return palavras_chaves;
    }),
    trabalhos: function (_trabalhos) {
      function trabalhos() {
        return _trabalhos.apply(this, arguments);
      }

      trabalhos.toString = function () {
        return _trabalhos.toString();
      };

      return trabalhos;
    }(function () {
      return trabalhos;
    })
  },
  created: function created() {},
  mounted: function mounted() {},

  methods: {},
  i18n: __WEBPACK_IMPORTED_MODULE_2__langs_anais__["a" /* i18n */]
});

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_remove_accents__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_remove_accents___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_remove_accents__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__langs_anais__ = __webpack_require__(93);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'anaisAutores',
  props: {},
  components: {},
  data: function data() {
    return {
      // a letra atual
      // se termina com _
      // é pq tem um computed
      letra: null,
      // todas as letras do alfabeto
      letras: ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'],
      // cada autor por letra
      autores_letra: {},
      // o que estou pesquisando
      pesquisa: ''
    };
  },

  filters: {},
  watch: {
    '$route.params.pesquisa': function $routeParamsPesquisa() {
      this.changePesquisaFromParam();
    }
  },
  computed: {
    autores_pesquisa: function autores_pesquisa() {
      if (this.pesquisa != '') {
        // se na string str
        // contem o this.pesquisa
        // retorna true
        var pesquisa = __WEBPACK_IMPORTED_MODULE_1_remove_accents___default()(this.pesquisa.toLowerCase());
        var find = function find(str) {
          return __WEBPACK_IMPORTED_MODULE_1_remove_accents___default()(str.toString().toLowerCase()).indexOf(pesquisa) != -1;
        };
        return this.autores.filter(function (a) {
          // vamos verificar se esse autor
          // tem alguma coisa em comum
          // com a pesquisa
          var possiveisStrs = [a.nome, a.instituicao];

          // retorna true se alguma das possiveis strings
          // conter a pesquisa
          for (var i = 0; i < possiveisStrs.length; i++) {
            var str = possiveisStrs[i];
            if (find(str)) {
              return true;
            }
          }
          // nao encontrei
          return false;
        });
      }

      // se não tem pesquisa
      // só retorna o cara da letra
      return this.autores_letra[this.letra];
    },


    // eu preciso fazer um computed
    // pq eu qro acessar essas variáveis diretamente do <template>
    eixos: function (_eixos) {
      function eixos() {
        return _eixos.apply(this, arguments);
      }

      eixos.toString = function () {
        return _eixos.toString();
      };

      return eixos;
    }(function () {
      return eixos;
    }),
    autores: function (_autores) {
      function autores() {
        return _autores.apply(this, arguments);
      }

      autores.toString = function () {
        return _autores.toString();
      };

      return autores;
    }(function () {
      return autores;
    }),
    palavras_chaves: function (_palavras_chaves) {
      function palavras_chaves() {
        return _palavras_chaves.apply(this, arguments);
      }

      palavras_chaves.toString = function () {
        return _palavras_chaves.toString();
      };

      return palavras_chaves;
    }(function () {
      return palavras_chaves;
    }),
    trabalhos: function (_trabalhos) {
      function trabalhos() {
        return _trabalhos.apply(this, arguments);
      }

      trabalhos.toString = function () {
        return _trabalhos.toString();
      };

      return trabalhos;
    }(function () {
      return trabalhos;
    })
  },
  created: function created() {
    var _this = this;

    // defino o autores_letra
    // primeiro, defino os arrays
    this.letras.forEach(function (l) {
      _this.autores_letra[l] = [];
    });
    // agora preencho
    this.autores.forEach(function (a) {
      // na página de autores
      // preciso de algumas estatísticas

      // a letra L
      var l = a.id[0];
      _this.autores_letra[l].push(a);
    });

    // agora eu mudo a letra
    this.letra = 'a';

    this.changePesquisaFromParam();
  },
  mounted: function mounted() {},
  methods: {
    changePesquisaFromParam: function changePesquisaFromParam() {
      var pesquisa = this.$route.params.pesquisa;
      if (pesquisa) {
        this.pesquisa = pesquisa;
      }
    }
  },
  i18n: __WEBPACK_IMPORTED_MODULE_2__langs_anais__["a" /* i18n */]
});

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__langs_anais__ = __webpack_require__(93);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'AnaisHeader',

  i18n: __WEBPACK_IMPORTED_MODULE_2__langs_anais__["a" /* i18n */],

  data: function data() {
    return {
      dados: {
        anais_cor_bg_menus: null,
        template: null
      }
    };
  },


  components: {},

  props: [],

  watch: {},

  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([this.$http.post(window.url + "admin/api", {
      type: "getAnaisInfo"
    })]).catch(function (err) {
      console.log(err);
    }).then(function (responses) {
      var responsePromises = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(responses), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var response = _step.value;

          responsePromises.push(response.json());
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(responsePromises);
    }).then(function (responses) {

      _this.dados = responses[0];
    });
  }
});

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_remove_accents__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_remove_accents___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_remove_accents__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__langs_anais__ = __webpack_require__(93);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'anaisMain',
  props: {},
  components: {},
  filters: {},
  watch: {},

  data: function data() {
    return {
      dados: {
        anais_cor_bg_menus: null
      }
    };
  },


  computed: {
    page: function page() {
      // retorna sempre uma string da página em que estamos
      var ret = this.$route.params.page;
      if (!ret) {
        return 'home';
      }
      return ret;
    },


    // eu preciso fazer um computed
    // pq eu qro acessar essas variáveis diretamente do <template>
    eixos: function (_eixos) {
      function eixos() {
        return _eixos.apply(this, arguments);
      }

      eixos.toString = function () {
        return _eixos.toString();
      };

      return eixos;
    }(function () {
      return eixos;
    }),
    autores: function (_autores) {
      function autores() {
        return _autores.apply(this, arguments);
      }

      autores.toString = function () {
        return _autores.toString();
      };

      return autores;
    }(function () {
      return autores;
    }),
    palavras_chaves: function (_palavras_chaves) {
      function palavras_chaves() {
        return _palavras_chaves.apply(this, arguments);
      }

      palavras_chaves.toString = function () {
        return _palavras_chaves.toString();
      };

      return palavras_chaves;
    }(function () {
      return palavras_chaves;
    }),
    trabalhos: function (_trabalhos) {
      function trabalhos() {
        return _trabalhos.apply(this, arguments);
      }

      trabalhos.toString = function () {
        return _trabalhos.toString();
      };

      return trabalhos;
    }(function () {
      return trabalhos;
    })
  },
  created: function created() {},
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([this.$http.post(window.url + "admin/api", {
      type: "getAnaisInfo"
    })]).catch(function (err) {
      console.log(err);
    }).then(function (responses) {
      var responsePromises = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(responses), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var response = _step.value;

          responsePromises.push(response.json());
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(responsePromises);
    }).then(function (responses) {

      _this.dados = responses[0];
    });
  },


  methods: {},
  i18n: __WEBPACK_IMPORTED_MODULE_4__langs_anais__["a" /* i18n */]
});

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_remove_accents__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_remove_accents___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_remove_accents__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__langs_anais__ = __webpack_require__(93);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'anaisTrabalho',
  props: {},
  components: {},
  data: function data() {
    return {};
  },

  filters: {},
  watch: {},
  computed: {
    trabalho: function trabalho() {
      if (this.$route.params.trabalho_id) {
        var trabalho_id = this.$route.params.trabalho_id;
        var ret = this.trabalhos.find(function (t) {
          return t.id == trabalho_id;
        });
        if (!ret) {
          // não encontrei o autor
          // volto para autores
          this.$router.replace('/trabalhos');
          return this.trabalhos[0];
        }
        return ret;
      }
      return null;
    },


    // eu preciso fazer um computed
    // pq eu qro acessar essas variáveis diretamente do <template>
    eixos: function (_eixos) {
      function eixos() {
        return _eixos.apply(this, arguments);
      }

      eixos.toString = function () {
        return _eixos.toString();
      };

      return eixos;
    }(function () {
      return eixos;
    }),
    autores: function (_autores) {
      function autores() {
        return _autores.apply(this, arguments);
      }

      autores.toString = function () {
        return _autores.toString();
      };

      return autores;
    }(function () {
      return autores;
    }),
    palavras_chaves: function (_palavras_chaves) {
      function palavras_chaves() {
        return _palavras_chaves.apply(this, arguments);
      }

      palavras_chaves.toString = function () {
        return _palavras_chaves.toString();
      };

      return palavras_chaves;
    }(function () {
      return palavras_chaves;
    }),
    trabalhos: function (_trabalhos) {
      function trabalhos() {
        return _trabalhos.apply(this, arguments);
      }

      trabalhos.toString = function () {
        return _trabalhos.toString();
      };

      return trabalhos;
    }(function () {
      return trabalhos;
    })
  },
  created: function created() {},
  mounted: function mounted() {},
  methods: {},
  i18n: __WEBPACK_IMPORTED_MODULE_2__langs_anais__["a" /* i18n */]
});

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_remove_accents__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_remove_accents___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_remove_accents__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__langs_anais__ = __webpack_require__(93);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'anaisTrabalhoRow',
  props: ['trabalho_id'],
  components: {},
  data: function data() {
    return {};
  },

  filters: {},
  watch: {},
  computed: {
    trabalho: function trabalho() {
      var _this = this;

      return this.trabalhos.find(function (t) {
        return t.id == _this.trabalho_id;
      });
    },

    // eu preciso fazer um computed
    // pq eu qro acessar essas variáveis diretamente do <template>
    eixos: function (_eixos) {
      function eixos() {
        return _eixos.apply(this, arguments);
      }

      eixos.toString = function () {
        return _eixos.toString();
      };

      return eixos;
    }(function () {
      return eixos;
    }),
    autores: function (_autores) {
      function autores() {
        return _autores.apply(this, arguments);
      }

      autores.toString = function () {
        return _autores.toString();
      };

      return autores;
    }(function () {
      return autores;
    }),
    palavras_chaves: function (_palavras_chaves) {
      function palavras_chaves() {
        return _palavras_chaves.apply(this, arguments);
      }

      palavras_chaves.toString = function () {
        return _palavras_chaves.toString();
      };

      return palavras_chaves;
    }(function () {
      return palavras_chaves;
    }),
    trabalhos: function (_trabalhos) {
      function trabalhos() {
        return _trabalhos.apply(this, arguments);
      }

      trabalhos.toString = function () {
        return _trabalhos.toString();
      };

      return trabalhos;
    }(function () {
      return trabalhos;
    })
  },
  created: function created() {},
  mounted: function mounted() {},
  methods: {},
  i18n: __WEBPACK_IMPORTED_MODULE_2__langs_anais__["a" /* i18n */]
});

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_remove_accents__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_remove_accents___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_remove_accents__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__langs_anais__ = __webpack_require__(93);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'anaisTrabalhos',
  props: {},
  components: {},
  data: function data() {
    return {
      // quantidade de páginas
      qtd_paginas: null,
      // quantidade de trabalhos por página
      qtd_trabalhos_pag: 10,
      // pagina atual
      pagina: 1,
      // a verdadeira variável de pesquisa
      pesquisa: ''
    };
  },

  filters: {},
  watch: {
    pesquisa: function pesquisa() {
      this.pagina = 1;
    },
    '$route.params.pesquisa': function $routeParamsPesquisa() {
      this.changePesquisaFromParam();
    }
  },
  computed: {
    trabalhos_filtrados: function trabalhos_filtrados() {
      var _this = this;

      // antes de retornar
      // chama essa função
      var ret = function ret(trabalhos) {
        // muda a quantidade de páginas disponíveis
        // se eu tenho um trabalho sobrando na próxima página
        // preciso adicionar um
        _this.qtd_paginas = Math.ceil(trabalhos.length / _this.qtd_trabalhos_pag);
        // volta para a página 1
        _this.pagina = 1;
        return trabalhos;
      };

      if (this.pesquisa == '') {
        return ret(this.trabalhos);
      }
      // se na string str
      // contem o this.pesquisa
      // retorna true
      var pesquisa = __WEBPACK_IMPORTED_MODULE_1_remove_accents___default()(this.pesquisa.toLowerCase());
      var find = function find(str) {
        return __WEBPACK_IMPORTED_MODULE_1_remove_accents___default()(str.toString().toLowerCase()).indexOf(pesquisa) != -1;
      };
      return ret(this.trabalhos.filter(function (t) {
        var possiveisStrs = [t.eixo.nome, t.id, t.titulo, t.autor.nome, t.autor.instituicao, t.palavras_chaves.map(function (p) {
          return p.palavra_chave;
        }).join(' '), t.resumo];
        // adiciona os nomes dos coautores
        t.coautores.forEach(function (c) {
          possiveisStrs.push(c.nome);
          possiveisStrs.push(c.instituicao);
        });

        // retorna true se alguma das possiveis strings
        // conter a pesquisa
        for (var i = 0; i < possiveisStrs.length; i++) {
          var str = possiveisStrs[i];
          if (find(str)) {
            return true;
          }
        }
        // nao encontrei
        return false;
      }));
    },
    trabalhos_pagina: function trabalhos_pagina() {
      var start = (this.pagina - 1) * this.qtd_trabalhos_pag;
      return this.trabalhos_filtrados.slice(start, start + this.qtd_trabalhos_pag);
    },
    trabalho: function trabalho() {
      if (this.$route.params.trabalho_id) {
        var trabalho_id = this.$route.params.trabalho_id;
        return this.trabalhos.find(function (t) {
          return t.id == trabalho_id;
        });
      }
      return null;
    },
    max_pag_diff: function max_pag_diff() {
      // o máximo de difenreça que uma pagina pode ter
      // se estou na página 1, posso ir até a 5
      // se estou na última, posso voltar 5
      var pagina = this.pagina;
      if (pagina < 4) {
        return 5 - pagina;
      }
      return 2;
    },


    // eu preciso fazer um computed
    // pq eu qro acessar essas variáveis diretamente do <template>
    eixos: function (_eixos) {
      function eixos() {
        return _eixos.apply(this, arguments);
      }

      eixos.toString = function () {
        return _eixos.toString();
      };

      return eixos;
    }(function () {
      return eixos;
    }),
    autores: function (_autores) {
      function autores() {
        return _autores.apply(this, arguments);
      }

      autores.toString = function () {
        return _autores.toString();
      };

      return autores;
    }(function () {
      return autores;
    }),
    palavras_chaves: function (_palavras_chaves) {
      function palavras_chaves() {
        return _palavras_chaves.apply(this, arguments);
      }

      palavras_chaves.toString = function () {
        return _palavras_chaves.toString();
      };

      return palavras_chaves;
    }(function () {
      return palavras_chaves;
    }),
    trabalhos: function (_trabalhos) {
      function trabalhos() {
        return _trabalhos.apply(this, arguments);
      }

      trabalhos.toString = function () {
        return _trabalhos.toString();
      };

      return trabalhos;
    }(function () {
      return trabalhos;
    })
  },
  created: function created() {
    this.changePesquisaFromParam();
  },
  mounted: function mounted() {},
  methods: {
    changePesquisaFromParam: function changePesquisaFromParam() {
      var pesquisa = this.$route.params.pesquisa;
      this.pesquisa = pesquisa ? pesquisa : '';
    },
    blurPesquisa: function blurPesquisa() {
      this.$router.replace({
        name: 'trabalhos',
        params: { pesquisa: this.pesquisa }
      });
    }
  },
  i18n: __WEBPACK_IMPORTED_MODULE_2__langs_anais__["a" /* i18n */]
});

/***/ }),
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(72)(true);
// imports


// module
exports.push([module.i, ".paginas[data-v-00252dc8]{text-align:center}.pagina-btn[data-v-00252dc8]{display:inline-block;cursor:pointer;padding:10px 16px;margin:0 5px;color:#000}.pagina-selected[data-v-00252dc8]{text-decoration:underline;font-weight:700}.pagina-btn[data-v-00252dc8]:hover{box-shadow:0 0 1px red;font-weight:700}", "", {"version":3,"sources":["/home2/fai/app.faiufscar.com/src/components/anais/AnaisTrabalhos.vue"],"names":[],"mappings":"AACA,0BACE,iBAAmB,CACpB,AACD,6BACE,qBAAsB,AACtB,eAAgB,AAChB,kBAAmB,AACnB,aAAc,AACd,UAAa,CACd,AACD,kCACE,0BAA2B,AAC3B,eAAkB,CACnB,AACD,mCACE,uBAAwB,AACxB,eAAkB,CACnB","file":"AnaisTrabalhos.vue","sourcesContent":["\n.paginas[data-v-00252dc8] {\n  text-align: center;\n}\n.pagina-btn[data-v-00252dc8] {\n  display: inline-block;\n  cursor: pointer;\n  padding: 10px 16px;\n  margin: 0 5px;\n  color: black;\n}\n.pagina-selected[data-v-00252dc8] {\n  text-decoration: underline;\n  font-weight: bold;\n}\n.pagina-btn[data-v-00252dc8]:hover {\n  box-shadow: 0 0 1px red;\n  font-weight: bold;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(72)(true);
// imports


// module
exports.push([module.i, ".button-content-new{text-align:center!important;border-radius:10px!important;padding:10px!important;font-weight:bolder!important;font-size:16px!important;text-transform:uppercase!important;margin-right:10px!important;width:19%!important;margin-bottom:30px!important}", "", {"version":3,"sources":["/home2/fai/app.faiufscar.com/src/components/anais/AnaisHeader.vue"],"names":[],"mappings":"AACA,oBACE,4BAA6B,AAC7B,6BAA8B,AAC9B,uBAAwB,AACxB,6BAA8B,AAC9B,yBAA0B,AAC1B,mCAAoC,AACpC,4BAA6B,AAC7B,oBAAsB,AACtB,4BAA8B,CAC/B","file":"AnaisHeader.vue","sourcesContent":["\n.button-content-new {\n  text-align:center !important;\n  border-radius:10px !important;\n  padding:10px !important;\n  font-weight:bolder !important;\n  font-size:16px !important;\n  text-transform:uppercase !important;\n  margin-right:10px !important;\n  width: 19% !important;\n  margin-bottom:30px !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(72)(true);
// imports


// module
exports.push([module.i, ".button-content-new{text-align:center!important;border-radius:10px!important;padding:10px 5px!important;font-weight:bolder!important;font-size:16px!important;text-transform:uppercase!important;margin-right:5px!important;width:19%!important;margin-bottom:30px!important}", "", {"version":3,"sources":["/home2/fai/app.faiufscar.com/src/components/anais/AnaisHeader.vue"],"names":[],"mappings":"AACA,oBACE,4BAA6B,AAC7B,6BAA8B,AAC9B,2BAA4B,AAC5B,6BAA8B,AAC9B,yBAA0B,AAC1B,mCAAoC,AACpC,2BAA4B,AAC5B,oBAAsB,AACtB,4BAA8B,CAC/B","file":"AnaisHeader.vue","sourcesContent":["\n.button-content-new {\n  text-align:center !important;\n  border-radius:10px !important;\n  padding:10px 5px !important;\n  font-weight:bolder !important;\n  font-size:16px !important;\n  text-transform:uppercase !important;\n  margin-right:5px !important;\n  width: 19% !important;\n  margin-bottom:30px !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(72)(true);
// imports


// module
exports.push([module.i, ".button-row[data-v-1023aae3]{padding:20px}.button-content[data-v-1023aae3]{text-align:center;box-shadow:0 3px 0 #b7453c;border-radius:8px;display:inline-block;width:100%;color:#000}.button-content[data-v-1023aae3]:hover{text-decoration:unset;box-shadow:0 0 3px 3px #b7453c;transition:.2s}", "", {"version":3,"sources":["/home2/fai/app.faiufscar.com/src/components/anais/AnaisHeader.vue"],"names":[],"mappings":"AACA,6BACI,YAAc,CACjB,AACD,iCACI,kBAAmB,AACnB,2BAAgC,AAChC,kBAAmB,AACnB,qBAAsB,AACtB,WAAY,AACZ,UAAa,CAChB,AACD,uCACI,sBAAuB,AACvB,+BAAoC,AACpC,cAAiB,CACpB","file":"AnaisHeader.vue","sourcesContent":["\n.button-row[data-v-1023aae3] {\r\n    padding: 20px;\n}\n.button-content[data-v-1023aae3] {\r\n    text-align: center;\r\n    box-shadow: 0px 3px 0px #B7453C;\r\n    border-radius: 8px;\r\n    display: inline-block;\r\n    width: 100%;\r\n    color: black;\n}\n.button-content[data-v-1023aae3]:hover {\r\n    text-decoration: unset;\r\n    box-shadow: 0px 0px 3px 3px #B7453C;\r\n    transition: 0.2s;\n}\r\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(72)(true);
// imports


// module
exports.push([module.i, ".letra[data-v-3b96ae2b]{cursor:pointer;width:3.84%;text-align:center;display:inline-block;color:#333;font-size:32px;font-family:monospace}.letra[data-v-3b96ae2b]:hover{font-weight:700}.letra-selected[data-v-3b96ae2b]{text-decoration:underline}a.a[data-v-3b96ae2b]{color:unset}a.a[data-v-3b96ae2b]:hover{text-decoration:unset;color:unset}.a[data-v-3b96ae2b]{padding:0 10px;margin:40px 0;border:1px solid darkred;border-top:0;border-left:0;cursor:pointer;display:block}.a[data-v-3b96ae2b]:hover{box-shadow:0 0 8px #ccc}.a-nome[data-v-3b96ae2b]{font-size:32px;padding:10px 0;color:#000}.a:hover .a-nome[data-v-3b96ae2b]{text-decoration:underline}.a-infos[data-v-3b96ae2b]{border-top:1px solid #ccc}.a-info[data-v-3b96ae2b]{display:inline-block;margin:10px;margin-left:0}", "", {"version":3,"sources":["/home2/fai/app.faiufscar.com/src/components/anais/AnaisAutores.vue"],"names":[],"mappings":"AACA,wBACE,eAAgB,AAChB,YAAa,AACb,kBAAmB,AACnB,qBAAsB,AACtB,WAAY,AACZ,eAAgB,AAChB,qBAAuB,CACxB,AACD,8BACE,eAAkB,CACnB,AACD,iCACE,yBAA2B,CAC5B,AAKD,qBACE,WAAa,CACd,AACD,2BACE,sBAAuB,AACvB,WAAa,CACd,AACD,oBACE,eAAgB,AAChB,cAAe,AACf,yBAA0B,AAC1B,aAAc,AACd,cAAe,AACf,eAAgB,AAChB,aAAe,CAChB,AACD,0BACE,uBAA6B,CAC9B,AACD,yBACE,eAAgB,AAChB,eAAgB,AAChB,UAAa,CACd,AACD,kCACE,yBAA2B,CAC5B,AACD,0BACE,yBAA2B,CAC5B,AACD,yBACE,qBAAsB,AACtB,YAAa,AACb,aAAe,CAChB","file":"AnaisAutores.vue","sourcesContent":["\n.letra[data-v-3b96ae2b] {\n  cursor: pointer;\n  width: 3.84%;\n  text-align: center;\n  display: inline-block;\n  color: #333;\n  font-size: 32px;\n  font-family: monospace;\n}\n.letra[data-v-3b96ae2b]:hover {\n  font-weight: bold;\n}\n.letra-selected[data-v-3b96ae2b] {\n  text-decoration: underline;\n}\n\n\n/* A é autor\nmas é o autor da lista de autores*/\na.a[data-v-3b96ae2b] {\n  color: unset;\n}\na.a[data-v-3b96ae2b]:hover {\n  text-decoration: unset;\n  color: unset;\n}\n.a[data-v-3b96ae2b] {\n  padding: 0 10px;\n  margin: 40px 0;\n  border: 1px solid darkred;\n  border-top: 0;\n  border-left: 0;\n  cursor: pointer;\n  display: block;\n}\n.a[data-v-3b96ae2b]:hover {\n  box-shadow: 0px 0px 8px #CCC;\n}\n.a-nome[data-v-3b96ae2b] {\n  font-size: 32px;\n  padding: 10px 0;\n  color: black;\n}\n.a:hover .a-nome[data-v-3b96ae2b] {\n  text-decoration: underline;\n}\n.a-infos[data-v-3b96ae2b] {\n  border-top: 1px solid #CCC;\n}\n.a-info[data-v-3b96ae2b] {\n  display: inline-block;\n  margin: 10px;\n  margin-left: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(72)(true);
// imports


// module
exports.push([module.i, ".box-1-new[data-v-3cdc4f8f]{width:100%;border-radius:10px;text-align:center;padding:40px;margin-bottom:20px}.box-1-num-new[data-v-3cdc4f8f]{font-size:55px;font-weight:700}.box-1-text-new[data-v-3cdc4f8f]{margin-top:20px}.box-1[data-v-3cdc4f8f]{text-align:center;color:#fff;padding:0 10px;width:50%}.box-1-child[data-v-3cdc4f8f]{background:#a62b22;border-radius:5px}.box-1-text[data-v-3cdc4f8f]{padding:15px 0}.box-1-num[data-v-3cdc4f8f]{background:#b7453c;font-size:42px;padding:20px 0;border-radius:5px 5px 0 0}#eixos-title[data-v-3cdc4f8f]{text-transform:unset;border-bottom:1px solid #ccc;padding-bottom:8px;margin-bottom:8px}#eixos[data-v-3cdc4f8f]{list-style-type:disc}a[data-v-3cdc4f8f]{color:unset}a[data-v-3cdc4f8f]:hover{text-decoration:none}", "", {"version":3,"sources":["/home2/fai/app.faiufscar.com/src/components/anais/AnaisMain.vue"],"names":[],"mappings":"AACA,4BACE,WAAW,AACX,mBAAmB,AACnB,kBAAkB,AAClB,aAAa,AACb,kBAAmB,CACpB,AACD,gCACE,eAAe,AACf,eAAiB,CAClB,AACD,iCACE,eAAgB,CACjB,AACD,wBACE,kBAAmB,AACnB,WAAa,AACb,eAAgB,AAChB,SAAW,CACZ,AACD,8BACE,mBAAoB,AACpB,iBAAmB,CACpB,AACD,6BACE,cAAgB,CACjB,AACD,4BACE,mBAAoB,AACpB,eAAgB,AAChB,eAAgB,AAChB,yBAA2B,CAC5B,AACD,8BACE,qBAAsB,AACtB,6BAA8B,AAC9B,mBAAoB,AACpB,iBAAmB,CACpB,AACD,wBACE,oBAAsB,CACvB,AACD,mBACE,WAAa,CACd,AACD,yBACE,oBAAsB,CACvB","file":"AnaisMain.vue","sourcesContent":["\n.box-1-new[data-v-3cdc4f8f] {\r\n  width:100%;\r\n  border-radius:10px;\r\n  text-align:center;\r\n  padding:40px;\r\n  margin-bottom:20px;\n}\n.box-1-num-new[data-v-3cdc4f8f] {\r\n  font-size:55px;\r\n  font-weight:bold;\n}\n.box-1-text-new[data-v-3cdc4f8f] {\r\n  margin-top:20px;\n}\n.box-1[data-v-3cdc4f8f] {\r\n  text-align: center;\r\n  color: white;\r\n  padding: 0 10px;\r\n  width: 50%;\n}\n.box-1-child[data-v-3cdc4f8f] {\r\n  background: #A62B22;\r\n  border-radius: 5px;\n}\n.box-1-text[data-v-3cdc4f8f] {\r\n  padding: 15px 0;\n}\n.box-1-num[data-v-3cdc4f8f] {\r\n  background: #B7453C;\r\n  font-size: 42px;\r\n  padding: 20px 0;\r\n  border-radius: 5px 5px 0 0;\n}\n#eixos-title[data-v-3cdc4f8f] {\r\n  text-transform: unset;\r\n  border-bottom: 1px solid #CCC;\r\n  padding-bottom: 8px;\r\n  margin-bottom: 8px;\n}\n#eixos[data-v-3cdc4f8f] {\r\n  list-style-type: disc;\n}\na[data-v-3cdc4f8f] {\r\n  color: unset;\n}\na[data-v-3cdc4f8f]:hover {\r\n  text-decoration: none;\n}\r\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(72)(true);
// imports


// module
exports.push([module.i, ".trabalho-id-wrapper[data-v-424e5632]{left:0;top:0;bottom:0;background:#b7453c;width:20px;position:absolute;color:#fff}.rotate[data-v-424e5632]{font-size:14px;left:50%;position:absolute;top:50%;-webkit-transform:translate(-50%,-50%) rotate(-90deg);transform:translate(-50%,-50%) rotate(-90deg)}.trabalho-id[data-v-424e5632]:before{content:\"#\"}.trabalho-id[data-v-424e5632]{letter-spacing:2px}.trabalho-titulo-autores[data-v-424e5632]{position:relative}.trabalho-titulo[data-v-424e5632]{font-size:32px;color:#000;line-height:32px;text-align:justify}.trabalho-titulo-autores-content[data-v-424e5632]{margin-left:24px}.download-wrapper[data-v-424e5632]{font-size:20px}.download-wrapper>div[data-v-424e5632]{margin-bottom:10px}.resumo[data-v-424e5632]{text-align:justify}.row-side-info[data-v-424e5632]{text-align:justify;margin-bottom:20px}.row-side-info sup[data-v-424e5632]{margin-right:5px}.row-side-info a[data-v-424e5632]{color:unset}.row-side-info a[data-v-424e5632]:hover{text-decoration:none}.instituicao[data-v-424e5632]{margin-bottom:10px}", "", {"version":3,"sources":["/home2/fai/app.faiufscar.com/src/components/anais/AnaisTrabalho.vue"],"names":[],"mappings":"AA+HA,sCACE,OAAQ,AACR,MAAO,AACP,SAAU,AACV,mBAAoB,AACpB,WAAY,AACZ,kBAAmB,AACnB,UAAa,CACd,AACD,yBACE,eAAgB,AAChB,SAAU,AACV,kBAAmB,AACnB,QAAS,AACT,sDAAuD,AAC/C,6CAA+C,CACxD,AACD,qCACE,WAAa,CACd,AACD,8BACE,kBAAoB,CACrB,AACD,0CACE,iBAAmB,CACpB,AACD,kCACE,eAAgB,AAChB,WAAa,AACb,iBAAkB,AAClB,kBAAoB,CACrB,AACD,kDACE,gBAAkB,CACnB,AACD,mCACE,cAAgB,CACjB,AACD,uCAEE,kBAAoB,CACrB,AACD,yBACE,kBAAoB,CACrB,AACD,gCACE,mBAAoB,AACpB,kBAAoB,CACrB,AACD,oCACE,gBAAkB,CACnB,AACD,kCACE,WAAa,CACd,AACD,wCACE,oBAAsB,CACvB,AACD,8BACE,kBAAoB,CACrB","file":"AnaisTrabalho.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/*o trabalho quando estou visualizando apenas um*/\n.trabalho-id-wrapper[data-v-424e5632] {\n  left: 0;\n  top: 0;\n  bottom: 0;\n  background: #B7453C;\n  width: 20px;\n  position: absolute;\n  color: white;\n}\n.rotate[data-v-424e5632] {\n  font-size: 14px;\n  left: 50%;\n  position: absolute;\n  top: 50%;\n  -webkit-transform: translate(-50%,-50%) rotate(-90deg);\n          transform: translate(-50%,-50%) rotate(-90deg);\n}\n.trabalho-id[data-v-424e5632]::before {\n  content: '#';\n}\n.trabalho-id[data-v-424e5632] {\n  letter-spacing: 2px;\n}\n.trabalho-titulo-autores[data-v-424e5632] {\n  position: relative;\n}\n.trabalho-titulo[data-v-424e5632] {\n  font-size: 32px;\n  color: black;\n  line-height: 32px;\n  text-align: justify;\n}\n.trabalho-titulo-autores-content[data-v-424e5632] {\n  margin-left: 24px;\n}\n.download-wrapper[data-v-424e5632] {\n  font-size: 20px;\n}\n.download-wrapper > div[data-v-424e5632] {\n  /*cada linha do download wrapper deve manter uma distância do outro*/\n  margin-bottom: 10px;\n}\n.resumo[data-v-424e5632] {\n  text-align: justify;\n}\n.row-side-info[data-v-424e5632] {\n  text-align: justify;\n  margin-bottom: 20px;\n}\n.row-side-info sup[data-v-424e5632] {\n  margin-right: 5px;\n}\n.row-side-info a[data-v-424e5632] {\n  color: unset;\n}\n.row-side-info a[data-v-424e5632]:hover {\n  text-decoration: none;\n}\n.instituicao[data-v-424e5632] {\n  margin-bottom: 10px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 188 */,
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(72)(true);
// imports


// module
exports.push([module.i, ".trabalho a[data-v-57630ea3],a.trabalho[data-v-57630ea3]{color:unset}.trabalho a[data-v-57630ea3]:hover,a:hover.trabalho[data-v-57630ea3]{color:unset;text-decoration:unset}.trabalho[data-v-57630ea3]{position:relative;display:block;border:1px solid #ccc;border-left:7px solid #333;margin:10px 0;box-shadow:1px 1px 1px #ccc;padding:10px}.trabalho-eixo[data-v-57630ea3]{display:block;margin-bottom:7px}.trabalho-autor[data-v-57630ea3]{font-size:90%;text-decoration:underline;display:inline-block;color:#eb593c!important}.trabalho-id[data-v-57630ea3]{position:absolute;right:-1px;bottom:-1px;border:1px solid #ccc;border-radius:2px;font-family:monospace}", "", {"version":3,"sources":["/home2/fai/app.faiufscar.com/src/components/anais/AnaisTrabalhoRow.vue"],"names":[],"mappings":"AA6DA,yDACE,WAAa,CACd,AACD,qEACE,YAAa,AACb,qBAAuB,CACxB,AACD,2BACE,kBAAmB,AACnB,cAAe,AACf,sBAAuB,AACvB,2BAA4B,AAC5B,cAAe,AACf,4BAA6B,AAC7B,YAAc,CACf,AACD,gCACE,cAAe,AACf,iBAAmB,CACpB,AACD,iCACE,cAAe,AACf,0BAA2B,AAC3B,qBAAsB,AACtB,uBAA0B,CAC3B,AACD,8BACE,kBAAmB,AACnB,WAAY,AACZ,YAAa,AACb,sBAAuB,AACvB,kBAAmB,AACnB,qBAAuB,CACxB","file":"AnaisTrabalhoRow.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\r\n/*cada linha de trabalhos t*/\n.trabalho a[data-v-57630ea3], a.trabalho[data-v-57630ea3] {\r\n  color: unset;\n}\n.trabalho a[data-v-57630ea3]:hover, a:hover.trabalho[data-v-57630ea3] {\r\n  color: unset;\r\n  text-decoration: unset;\n}\n.trabalho[data-v-57630ea3] {\r\n  position: relative;\r\n  display: block;\r\n  border: 1px solid #CCC;\r\n  border-left: 7px solid #333;\r\n  margin: 10px 0;\r\n  box-shadow: 1px 1px 1px #CCC;\r\n  padding: 10px;\n}\n.trabalho-eixo[data-v-57630ea3] {\r\n  display: block;\r\n  margin-bottom: 7px;\n}\n.trabalho-autor[data-v-57630ea3] {\r\n  font-size: 90%;\r\n  text-decoration: underline;\r\n  display: inline-block;\r\n  color: #eb593c !important;\n}\n.trabalho-id[data-v-57630ea3] {\r\n  position: absolute;\r\n  right: -1px;\r\n  bottom: -1px;\r\n  border: 1px solid #CCC;\r\n  border-radius: 2px;\r\n  font-family: monospace;\n}\r\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(72)(true);
// imports


// module
exports.push([module.i, ".autor[data-v-57724486]{padding:0 10px;margin:40px 0;border:1px solid #333;border-top:0;border-left:0;cursor:pointer;display:block}.autor[data-v-57724486]:hover{box-shadow:0 0 8px #ccc}.autor-nome[data-v-57724486]{padding:10px 0}.autor:hover .autor-nome[data-v-57724486]{text-decoration:underline}.autor-infos[data-v-57724486]{border-top:1px solid #ccc}.autor-info[data-v-57724486]{display:inline-block;margin:10px;margin-left:0}.autor-nome[data-v-57724486]{color:#000;font-size:32px;padding-top:20px;padding-bottom:9px}.autor-instituicao[data-v-57724486]{font-size:14px;color:unset}.autor-nome-table[data-v-57724486]{border-bottom:1px solid #bbb}.eixos[data-v-57724486]{border-left:3px solid #333}.eixo[data-v-57724486]{border-top:3px solid #333;margin-left:-15px;padding-left:15px;padding-top:15px;padding-bottom:15px;text-align:justify}#eixos-title[data-v-57724486]{margin-bottom:10px}", "", {"version":3,"sources":["/home2/fai/app.faiufscar.com/src/components/anais/AnaisAutor.vue"],"names":[],"mappings":"AA8EA,wBACE,eAAgB,AAChB,cAAe,AACf,sBAAuB,AACvB,aAAc,AACd,cAAe,AACf,eAAgB,AAChB,aAAe,CAChB,AACD,8BACE,uBAA6B,CAC9B,AACD,6BAEE,cAAgB,CAEjB,AACD,0CACE,yBAA2B,CAC5B,AACD,8BACE,yBAA2B,CAC5B,AACD,6BACE,qBAAsB,AACtB,YAAa,AACb,aAAe,CAChB,AAKD,6BACE,WAAa,AACb,eAAgB,AAChB,iBAAkB,AAClB,kBAAoB,CACrB,AACD,oCACE,eAAgB,AAChB,WAAa,CACd,AACD,mCACE,4BAA8B,CAC/B,AACD,wBACE,0BAA4B,CAC7B,AACD,uBACE,0BAA2B,AAC3B,kBAAmB,AACnB,kBAAmB,AACnB,iBAAkB,AAClB,oBAAqB,AACrB,kBAAoB,CACrB,AACD,8BACE,kBAAoB,CACrB","file":"AnaisAutor.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/* A é autor\nmas é o autor da lista de autores*/\n.autor[data-v-57724486] {\n  padding: 0 10px;\n  margin: 40px 0;\n  border: 1px solid #333;\n  border-top: 0;\n  border-left: 0;\n  cursor: pointer;\n  display: block;\n}\n.autor[data-v-57724486]:hover {\n  box-shadow: 0px 0px 8px #CCC;\n}\n.autor-nome[data-v-57724486] {\n  font-size: 32px;\n  padding: 10px 0;\n  color: black;\n}\n.autor:hover .autor-nome[data-v-57724486] {\n  text-decoration: underline;\n}\n.autor-infos[data-v-57724486] {\n  border-top: 1px solid #CCC;\n}\n.autor-info[data-v-57724486] {\n  display: inline-block;\n  margin: 10px;\n  margin-left: 0;\n}\n\n\n/*agora são as classes\nde quem tá visualizando um autor só*/\n.autor-nome[data-v-57724486] {\n  color: black;\n  font-size: 32px;\n  padding-top: 20px;\n  padding-bottom: 9px;\n}\n.autor-instituicao[data-v-57724486] {\n  font-size: 14px;\n  color: unset;\n}\n.autor-nome-table[data-v-57724486] {\n  border-bottom: 1px solid #BBB;\n}\n.eixos[data-v-57724486] {\n  border-left: 3px solid #333;\n}\n.eixo[data-v-57724486] {\n  border-top: 3px solid #333;\n  margin-left: -15px;\n  padding-left: 15px;\n  padding-top: 15px;\n  padding-bottom: 15px;\n  text-align: justify;\n}\n#eixos-title[data-v-57724486] {\n  margin-bottom: 10px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row col-md-12"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('h1', [_vm._v(_vm._s(_vm._f("capitalize")(_vm.$tc('trabalho', 2))) + " "), _c('small', [_vm._v("(" + _vm._s(_vm.trabalhos_filtrados.length) + "/" + _vm._s(_vm.trabalhos.length) + ")")])]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pesquisa),
      expression: "pesquisa"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('placeholder_pesquise_por_titulo')
    },
    domProps: {
      "value": (_vm.pesquisa)
    },
    on: {
      "blur": function($event) {
        _vm.blurPesquisa()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pesquisa = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [(_vm.trabalhos_filtrados.length > 0) ? _c('div', [_vm._l((_vm.trabalhos_pagina), function(t) {
    return _c('anais-trabalho-row', {
      key: t.id,
      attrs: {
        "trabalho_id": t.id
      }
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "paginas"
  }, [(_vm.pagina > 1) ? _c('div', {
    staticClass: "pagina-btn",
    on: {
      "click": function($event) {
        _vm.pagina = 1
      }
    }
  }, [_vm._v("«")]) : _vm._e(), _vm._v(" "), (_vm.pagina > 1) ? _c('div', {
    staticClass: "pagina-btn",
    on: {
      "click": function($event) {
        _vm.pagina--
      }
    }
  }, [_vm._v("<")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.qtd_paginas), function(i) {
    return (Math.abs(_vm.pagina - i) <= _vm.max_pag_diff) ? _c('div', {
      staticClass: "pagina-btn",
      class: {
        'pagina-selected': _vm.pagina == i
      },
      on: {
        "click": function($event) {
          _vm.pagina = i
        }
      }
    }, [_vm._v(_vm._s(i))]) : _vm._e()
  }), _vm._v(" "), (_vm.pagina < _vm.qtd_paginas) ? _c('div', {
    staticClass: "pagina-btn",
    on: {
      "click": function($event) {
        _vm.pagina++
      }
    }
  }, [_vm._v(">")]) : _vm._e(), _vm._v(" "), (_vm.pagina < _vm.qtd_paginas) ? _c('div', {
    staticClass: "pagina-btn",
    on: {
      "click": function($event) {
        _vm.pagina = _vm.qtd_paginas
      }
    }
  }, [_vm._v("»")]) : _vm._e()], 2)], 2) : _c('div', [_c('h3', [_vm._v(_vm._s(_vm.$t('nao_ha_trabalhos_pesquisa')))])])])])
},staticRenderFns: []}

/***/ }),
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.dados.anais_cor_bg_menus == null || _vm.dados.anais_cor_bg_menus == '' || !_vm.dados.anais_cor_bg_menus) ? _c('div', {
    staticStyle: {
      "width": "100%",
      "text-align": "center"
    }
  }, [_c('table', {
    attrs: {
      "width": "100%",
      "border": "0"
    }
  }, [_c('tr', [_c('td', {
    staticClass: "button-row",
    attrs: {
      "width": "20%"
    }
  }, [_c('router-link', {
    staticClass: "button-content",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("\n          " + _vm._s(_vm._f("capitalize")(_vm.$t('inicio'))) + "\n          "), _c('br'), _vm._v(" "), _c('i', {
    staticClass: "fa fa-home"
  })])], 1), _vm._v(" "), _c('td', {
    staticClass: "button-row",
    attrs: {
      "width": "20%"
    }
  }, [_c('router-link', {
    staticClass: "button-content",
    attrs: {
      "to": "/corpo_editorial"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('corpo_editorial')) + "\n          "), _c('br'), _vm._v(" "), _c('i', {
    staticClass: "fa fa-book"
  })])], 1), _vm._v(" "), _c('td', {
    staticClass: "button-row",
    attrs: {
      "width": "20%"
    }
  }, [_c('router-link', {
    staticClass: "button-content",
    attrs: {
      "to": "/autores"
    }
  }, [_vm._v("\n          " + _vm._s(_vm._f("capitalize")(_vm.$tc('autor', 2))) + "\n          "), _c('br'), _vm._v(" "), _c('i', {
    staticClass: "fa fa-users"
  })])], 1), _vm._v(" "), _c('td', {
    staticClass: "button-row",
    attrs: {
      "width": "20%"
    }
  }, [_c('router-link', {
    staticClass: "button-content",
    attrs: {
      "to": "/eixos"
    }
  }, [_vm._v("\n          " + _vm._s(_vm._f("capitalize")(_vm.$tc('eixo', 2))) + "\n          "), _c('br'), _vm._v(" "), _c('i', {
    staticClass: "fa fa-plus"
  })])], 1), _vm._v(" "), _c('td', {
    staticClass: "button-row",
    attrs: {
      "width": "20%"
    }
  }, [_c('router-link', {
    staticClass: "button-content",
    attrs: {
      "to": "/trabalhos"
    }
  }, [_vm._v("\n          " + _vm._s(_vm._f("capitalize")(_vm.$tc('trabalho', 2))) + "\n          "), _c('br'), _vm._v(" "), _c('i', {
    staticClass: "fa fa-pencil"
  })])], 1)])])]) : _c('div', {
    staticClass: "col-md-12"
  }, [_c('router-link', {
    staticClass: "button-content-new col-md-2",
    style: ({
      background: _vm.dados.anais_cor_bg_menus,
      border: _vm.dados.anais_cor_bg_menus + ' solid 1px',
      color: _vm.dados.anais_cor_fonte_menus
    }),
    attrs: {
      "to": "/"
    }
  }, [_vm._v("\n    " + _vm._s(_vm._f("capitalize")(_vm.$t('inicio'))) + "\n  ")]), _vm._v(" "), _c('router-link', {
    staticClass: "button-content-new col-md-2",
    style: ({
      background: _vm.dados.anais_cor_bg_menus,
      border: _vm.dados.anais_cor_bg_menus + ' solid 1px',
      color: _vm.dados.anais_cor_fonte_menus
    }),
    attrs: {
      "to": "/corpo_editorial"
    }
  }, [_vm._v("\n    " + _vm._s(_vm._f("capitalize")(_vm.$t('corpo_editorial'))) + "\n  ")]), _vm._v(" "), _c('router-link', {
    staticClass: "button-content-new col-md-2",
    style: ({
      background: _vm.dados.anais_cor_bg_menus,
      border: _vm.dados.anais_cor_bg_menus + ' solid 1px',
      color: _vm.dados.anais_cor_fonte_menus
    }),
    attrs: {
      "to": "/autores"
    }
  }, [_vm._v("\n    " + _vm._s(_vm._f("capitalize")(_vm.$tc('autor', 2))) + "\n  ")]), _vm._v(" "), _c('router-link', {
    staticClass: "button-content-new col-md-2",
    style: ({
      background: _vm.dados.anais_cor_bg_menus,
      border: _vm.dados.anais_cor_bg_menus + ' solid 1px',
      color: _vm.dados.anais_cor_fonte_menus
    }),
    attrs: {
      "to": "/eixos"
    }
  }, [_vm._v("\n    " + _vm._s(_vm._f("capitalize")(_vm.$tc('eixo', 2))) + "\n  ")]), _vm._v(" "), _c('router-link', {
    staticClass: "button-content-new col-md-2",
    style: ({
      background: _vm.dados.anais_cor_bg_menus,
      border: _vm.dados.anais_cor_bg_menus + ' solid 1px',
      color: _vm.dados.anais_cor_fonte_menus
    }),
    attrs: {
      "to": "/trabalhos"
    }
  }, [_vm._v("\n    " + _vm._s(_vm._f("capitalize")(_vm.$tc('trabalho', 2))) + "\n  ")])], 1)
},staticRenderFns: []}

/***/ }),
/* 207 */,
/* 208 */,
/* 209 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row col-md-12"
  }, [_c('div', {
    staticClass: "col-md-3 col-md-push-9"
  }, [_c('h1', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._v(_vm._s(_vm._f("capitalize")(_vm.$t('pesquisa'))))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pesquisa),
      expression: "pesquisa"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('placeholder_pesquise_por_nome')
    },
    domProps: {
      "value": (_vm.pesquisa)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pesquisa = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9 col-md-pull-3"
  }, [_c('div', [_c('h1', [_vm._v(_vm._s(_vm.$tc('autor', 2)) + " "), _c('small', [_vm._v("(" + _vm._s(_vm.autores_pesquisa.length) + "/" + _vm._s(_vm.autores.length) + ")")])]), _vm._v(" "), (_vm.pesquisa === '') ? _c('div', {
    staticClass: "letra-parent",
    staticStyle: {
      "margin-top": "10px",
      "margin-bottom": "20px"
    }
  }, _vm._l((_vm.letras), function(l) {
    return _c('div', {
      staticClass: "letra",
      class: {
        'letra-selected': _vm.letra == l
      },
      on: {
        "click": function($event) {
          _vm.letra = l
        }
      }
    }, [_vm._v("\n            " + _vm._s(_vm._f("upper")(l)) + "\n          ")])
  })) : _vm._e()]), _vm._v(" "), _c('div', [(_vm.autores_pesquisa.length === 0) ? _c('div', [(_vm.pesquisa !== '' || !_vm.letra) ? _c('span', [_vm._v(_vm._s(_vm.$t('nenhuma_pessoa_encontrada')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('nenhuma_pessoa_encontrada_com_letra', {
    letra: _vm.letra.toUpperCase()
  })))])]) : _c('div', _vm._l((_vm.autores_pesquisa), function(a) {
    return _c('router-link', {
      key: a.id,
      staticClass: "a",
      attrs: {
        "to": '/autor/' + a.id
      }
    }, [_c('div', {
      staticClass: "a-nome",
      staticStyle: {
        "line-height": "100%",
        "font-size": "25px"
      }
    }, [_vm._v(_vm._s(a.nome))]), _vm._v(" "), _c('div', {
      staticClass: "a-instituicao"
    }, [_vm._v(_vm._s(a.instituicao))]), _vm._v(" "), _c('div', {
      staticClass: "a-infos"
    }, [_c('div', {
      staticClass: "a-info"
    }, [_c('b', [_vm._v(_vm._s(a.todos_trabalhos.length))]), _vm._v("\n                " + _vm._s(_vm.$tc('publicacao', a.todos_trabalhos.length)) + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "a-info"
    }, [_c('b', [_vm._v(_vm._s(a.eixos.length))]), _vm._v(" " + _vm._s(_vm.$tc('eixo_tematico', a.eixos.length)))])])])
  }))])])])])
},staticRenderFns: []}

/***/ }),
/* 210 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.page == 'home') ? _c('div', [_c('div', {
    staticClass: "row col-md-12"
  }, [_c('div', {
    staticClass: "col-md-9"
  }, [_vm._t("home")], 2), _vm._v(" "), (_vm.dados.anais_cor_bg_menus == null || _vm.dados.anais_cor_bg_menus == '' || !_vm.dados.anais_cor_bg_menus) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', [_c('div', {
    staticClass: "box-1 pull-left"
  }, [_c('div', {
    staticClass: "box-1-child"
  }, [_c('div', {
    staticClass: "box-1-num",
    attrs: {
      "id": "trabalhos_publicados"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.trabalhos.length) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "box-1-text"
  }, [_vm._v(_vm._s(_vm._f("capitalize")(_vm.$tc('trabalho_publicado', 2))))])])]), _vm._v(" "), _c('div', {
    staticClass: "box-1 pull-right"
  }, [_c('div', {
    staticClass: "box-1-child"
  }, [_c('div', {
    staticClass: "box-1-num",
    attrs: {
      "id": "eixos_tematicos"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.eixos.length) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "box-1-text"
  }, [_vm._v(_vm._s(_vm._f("capitalize")(_vm.$tc('eixo_tematico', 2))))])])])])]) : _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', [_c('div', {
    staticClass: "box-1-new pull-left",
    style: ({
      background: _vm.dados.anais_cor_bg_stats,
      border: _vm.dados.anais_cor_bg_stats + ' solid 1px',
      color: _vm.dados.anais_cor_fonte_stats
    })
  }, [_c('div', {
    staticClass: "box-1-child-new"
  }, [_c('div', {
    staticClass: "box-1-num-new",
    attrs: {
      "id": "trabalhos_publicados"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.trabalhos.length) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "box-1-text-new"
  }, [_vm._v(_vm._s(_vm._f("capitalize")(_vm.$tc('trabalho_publicado', 2))))])])]), _vm._v(" "), _c('div', {
    staticClass: "box-1-new pull-right",
    style: ({
      background: _vm.dados.anais_cor_bg_stats,
      border: _vm.dados.anais_cor_bg_stats + ' solid 1px',
      color: _vm.dados.anais_cor_fonte_stats
    })
  }, [_c('div', {
    staticClass: "box-1-child-new"
  }, [_c('div', {
    staticClass: "box-1-num-new",
    attrs: {
      "id": "eixos_tematicos"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.eixos.length) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "box-1-text-new"
  }, [_vm._v(_vm._s(_vm._f("capitalize")(_vm.$tc('eixo_tematico', 2))))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12",
    domProps: {
      "innerHTML": _vm._s(_vm.dados.anais_msg_home_stats)
    }
  }, [_vm._v(_vm._s(_vm.dados.anais_msg_home_stats))])])])])]) : (_vm.page == 'corpo_editorial') ? _c('div', {
    staticClass: "col-md-12"
  }, [_vm._t("corpo_editorial")], 2) : (_vm.eixos) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('h1', {
    attrs: {
      "id": "eixos-title"
    }
  }, [_vm._v(_vm._s(_vm._f("capitalize")(_vm.$tc('eixo', 2))))]), _vm._v(" "), _c('ul', {
    attrs: {
      "id": "eixos"
    }
  }, _vm._l((_vm.eixos), function(e) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": {
          name: 'trabalhos',
          params: {
            pesquisa: e.nome
          }
        }
      }
    }, [_vm._v("\n        " + _vm._s(e.nome) + " (" + _vm._s(e.trabalhos.length) + ")\n      ")])], 1)
  }))]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 211 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row col-md-12"
  }, [_c('div', {
    class: {
      'col-md-10': _vm.trabalho.trabalho_completo != '', 'col-md-12': _vm.trabalho.trabalho_completo == ''
    }
  }, [_c('div', {
    staticClass: "trabalho-titulo-autores"
  }, [_c('div', {
    staticClass: "trabalho-id-wrapper"
  }, [_c('div', {
    staticClass: "rotate"
  }, [_c('div', {
    staticClass: "trabalho-id"
  }, [_vm._v(_vm._s(_vm.trabalho.id))])])]), _vm._v(" "), _c('div', {
    staticClass: "trabalho-titulo-autores-content"
  }, [_c('div', {
    staticClass: "trabalho-titulo"
  }, [_vm._v(_vm._s(_vm.trabalho.titulo))]), _vm._v(" "), _c('div', {
    staticClass: "trabalho-autores"
  }, [_vm._l((_vm.trabalho.todos_autores), function(a, index) {
    return [(index != 0) ? _c('span', [_vm._v(" ; ")]) : _vm._e(), _vm._v(" "), _c('router-link', {
      staticClass: "trabalho-autor",
      attrs: {
        "to": '/autor/' + a.id
      }
    }, [_vm._v(_vm._s(a.nome)), _c('sup', [_vm._v(_vm._s(_vm.trabalho.instituicoes.indexOf(a.instituicao) + 1))])])]
  })], 2)])])]), _vm._v(" "), (_vm.trabalho.trabalho_completo != '') ? _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "text-right download-wrapper"
  }, [_c('div', [_c('a', {
    staticClass: "btn btn-primary btn-lg text-center",
    attrs: {
      "href": _vm.trabalho.trabalho_completo
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" "), _c('br'), _vm._v("\n            " + _vm._s(_vm.$t('baixar_trabalho')) + "\n          ")])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row-side-info"
  }, [_c('div', [_c('b', [_vm._v(_vm._s(_vm._f("capitalize")(_vm.$tc('instituicao', 2))))])]), _vm._v(" "), _vm._l((_vm.trabalho.instituicoes), function(i, index) {
    return _c('div', [_c('router-link', {
      attrs: {
        "to": {
          name: 'trabalhos',
          params: {
            pesquisa: i
          }
        }
      }
    }, [_c('sup', [_vm._v(_vm._s(index + 1))]), _vm._v(_vm._s(i) + "\n          ")])], 1)
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "row-side-info"
  }, [_c('div', [_c('b', [_vm._v(_vm._s(_vm._f("capitalize")(_vm.$tc('eixo', 2))))])]), _vm._v(" "), _c('div', [_c('router-link', {
    attrs: {
      "to": {
        name: 'trabalhos',
        params: {
          pesquisa: _vm.trabalho.eixo.nome
        }
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.trabalho.eixo.nome) + "\n          ")])], 1)]), _vm._v(" "), (_vm.trabalho.palavras_chaves.length) ? _c('div', {
    staticClass: "row-side-info"
  }, [_c('div', [_c('b', [_vm._v(_vm._s(_vm._f("capitalize")(_vm.$tc('palavra_chave', 2))))])]), _vm._v(" "), _vm._l((_vm.trabalho.palavras_chaves), function(p, index) {
    return _c('div', [_c('router-link', {
      attrs: {
        "to": {
          name: 'trabalhos',
          params: {
            pesquisa: p.palavra_chave
          }
        }
      }
    }, [_c('sup', [_vm._v(_vm._s(index + 1))]), _vm._v(_vm._s(p.palavra_chave) + "\n          ")])], 1)
  })], 2) : _vm._e()]), _vm._v(" "), (_vm.trabalho.resumo != '') ? [_c('div', {
    staticClass: "col-md-12 resumo"
  }, [_c('b', [_vm._v(_vm._s(_vm._f("capitalize")(_vm.$tc('resumo', 1))) + ":")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 resumo"
  }, _vm._l((_vm.trabalho.resumo_parsed.split('\n')), function(line) {
    return (line.trim() != '') ? _c('p', [_vm._v("\n          " + _vm._s(line) + "\n        ")]) : _vm._e()
  }))] : _vm._e()], 2)])
},staticRenderFns: []}

/***/ }),
/* 212 */,
/* 213 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.trabalho) ? _c('a', {
    staticClass: "trabalho",
    attrs: {
      "href": _vm.trabalho.href,
      "target": _vm.trabalho.target
    }
  }, [_c('div', {
    staticClass: "trabalho-nome"
  }, [_vm._v(_vm._s(_vm.trabalho.titulo))]), _vm._v(" "), _c('small', {
    staticClass: "trabalho-eixo"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'trabalhos',
        params: {
          pesquisa: _vm.trabalho.eixo.nome
        }
      }
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.trabalho.eixo.nome))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "trabalho-autores"
  }, [_vm._l((_vm.trabalho.todos_autores), function(a, index) {
    return [(index != 0) ? _c('span', [_vm._v(" ; ")]) : _vm._e(), _vm._v(" "), _c('router-link', {
      staticClass: "trabalho-autor",
      attrs: {
        "to": '/autor/' + a.id
      }
    }, [_vm._v(_vm._s(a.nome))])]
  })], 2), _vm._v(" "), (_vm.trabalho.palavras_chaves.length) ? _c('small', {
    staticClass: "trabalho-palavras-chaves"
  }, [_vm._l((_vm.trabalho.palavras_chaves), function(p, index) {
    return [(index != 0) ? [_vm._v(", ")] : _vm._e(), _vm._v(" "), _c('router-link', {
      attrs: {
        "to": {
          name: 'trabalhos',
          params: {
            pesquisa: p.palavra_chave
          }
        }
      }
    }, [_vm._v("\n        " + _vm._s(p.palavra_chave) + "\n      ")])]
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "trabalho-id"
  }, [_vm._v(_vm._s(_vm.trabalho.id))])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 214 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "autor-nome-table",
    attrs: {
      "width": "100%"
    }
  }, [_c('tr', [_c('td', {
    staticClass: "autor-nome",
    staticStyle: {
      "line-height": "100%",
      "font-size": "25px"
    }
  }, [_vm._v(_vm._s(_vm.autor.nome))]), _vm._v(" "), _c('td', {
    staticClass: "autor-instituicao",
    attrs: {
      "valign": "bottom",
      "align": "right",
      "width": "40%"
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'trabalhos',
        params: {
          pesquisa: _vm.autor.instituicao
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.autor.instituicao))])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "autor-infos"
  }, [_c('div', {
    staticClass: "autor-info"
  }, [_c('b', [_vm._v(_vm._s(_vm.autor.todos_trabalhos.length))]), _vm._v(" " + _vm._s(_vm.$tc('publicacao', _vm.autor.todos_trabalhos.length)))]), _vm._v(" "), _c('div', {
    staticClass: "autor-info"
  }, [_c('b', [_vm._v(_vm._s(_vm.autor.eixos.length))]), _vm._v(" " + _vm._s(_vm.$tc('eixo_tematico', _vm.autor.eixos.length)))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-9"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$tc('trabalho', 2)) + " "), _c('small', [_vm._v("(" + _vm._s(Object.keys(_vm.autor.todos_trabalhos).length) + ")")])]), _vm._v(" "), _vm._l((_vm.autor.todos_trabalhos), function(t) {
    return _c('anais-trabalho-row', {
      key: t.id,
      attrs: {
        "trabalho_id": t.id
      }
    })
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 eixos"
  }, [_c('h1', {
    attrs: {
      "id": "eixos-title"
    }
  }, [_vm._v(_vm._s(_vm._f("capitalize")(_vm.$t('eixos_publicados'))) + " "), _c('small', [_vm._v("(" + _vm._s(_vm.autor.eixos.length) + ")")])]), _vm._v(" "), _vm._l((_vm.autor.eixos), function(e) {
    return _c('div', {
      staticClass: "eixo"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'trabalhos',
          params: {
            pesquisa: e.nome
          }
        }
      }
    }, [_vm._v("\n          " + _vm._s(e.nome) + "\n        ")])], 1)
  })], 2)])])
},staticRenderFns: []}

/***/ }),
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(175);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(73)("2d664053", content, true);

/***/ }),
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(179);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(73)("c81753e2", content, true);

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(180);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(73)("f8d3a724", content, true);

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(181);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(73)("6501edec", content, true);

/***/ }),
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(185);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(73)("253c7c7a", content, true);

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(186);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(73)("10cbbe61", content, true);

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(187);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(73)("3a9a5709", content, true);

/***/ }),
/* 233 */,
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(189);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(73)("581516c8", content, true);

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(190);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(73)("b5581e3a", content, true);

/***/ })
]));


// WEBPACK FOOTER //
// static/js/0.7a7bd7e5ca60b6d1bff6.js